/*
 * Copyright (C) 2026 BIRU
 *
 * This file is part of Tenzu.
 *
 * Tenzu is free software: you can redistribute it and/or modify it
 * under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 *
 * You can contact BIRU at ask@biru.sh
 *
 */

import * as z from "zod/v4";
import { isoDatetime, optionalNullable } from "../base/schema-utils";

export const projectLinkNestedSchema = z.object({
  id: z.string(),
  workspaceId: z.string(),
  name: z.string().min(1).max(80),
  slug: z.string(),
  landingPage: z.string(),
});
export type ProjectLinkNested = z.infer<typeof projectLinkNestedSchema>;

export const projectNestedSchema = projectLinkNestedSchema.extend({
  logo: z.string().apply(optionalNullable),
  description: z.string(),
  color: z.int(),
  modifiedAt: isoDatetime.apply(optionalNullable),
});
export type ProjectNested = z.infer<typeof projectNestedSchema>;
